import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';
import { ItemCodeCell } from './item-code-cell';

export const ItemCode: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Item Code',
  minWidth: 65,
  accessorFn: (product) => product.item_code || product.suggested_item_code,
  cell: ({ item: product }) => <ItemCodeCell product={product} />,
  gloss:
    "Your store's item code for this product. If you haven't set one, Orderbot suggests one based on the barcode.",
});
